<template>
  <div
    class="simiot-card-box"
    style="margin-bottom: 10px"
  >
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :xl="8" :xxl="6">
          <a-form-item label="订单状态">
            <a-select
              mode="multiple"
              v-decorator="['status', {initialValue: orderStatus} ]"
              allow-clear
            >
              <a-select-option
                v-for="status in statusOptions"
                :key="status.value"
                :value="status.value"
              >
                {{ status.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="订单编号">
            <a-input
              v-decorator="['order_no', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="客户名称">
            <a-input
              v-decorator="['agent_name', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item label="项目状态">
            <a-select
              mode="multiple"
              v-decorator="['item_status', {initialValue: itemOrderStatus} ]"
              allow-clear
            >
              <a-select-option
                v-for="status in itemStatusOptions"
                :key="status.value"
                :value="status.value"
              >
                {{ status.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6" v-show="expand">
          <a-form-item label="项目编号">
            <a-input
              v-decorator="['item_no', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6" v-show="expand">
          <a-form-item label="订单创建时间">
            <a-range-picker v-decorator="['created_at']" />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
              <a-button :style="{ fontSize: '12px', lineHeight: '32px' }" @click="toggle">
                更多条件
                <a-icon :type="expand ? 'up' : 'down'" />
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { findAgentPreOrderStatusOptions } from '@/api/agent_pre_order'
import { findAgentPreOrderItemStatusOptions } from '@/api/agent_pre_order_item'
import { formatRangeBeginDate, formatRangeEndDate } from '@/utils/time'

export default {
  name: 'SearchAgentPreOrder',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'agent_pre_order_search' }),
      expand: false,
      statusOptions: [],
      itemStatusOptions: [],
      orderStatus: [],
      itemOrderStatus: []
    }
  },
  created() {
    this.fetchAgentPreOrderStatusOptions()
    this.fetchAgentPreOrderItemStatusOptions()
  },
  methods: {
    toggle() {
      this.expand = !this.expand
    },

    fetchAgentPreOrderStatusOptions() {
      findAgentPreOrderStatusOptions().then((res) => {
        this.statusOptions = res.data
      })
    },

    fetchAgentPreOrderItemStatusOptions() {
      findAgentPreOrderItemStatusOptions().then((res) => {
        this.itemStatusOptions = res.data
        if (this.$store.getters.userRole === 'purchaser') {
          this.itemOrderStatus = ['check_resource_all', 'check_resource_party_of']
        } else if (this.$store.getters.userRole === 'storekeeper') {
          this.itemOrderStatus = ['check_store']
        }
      })
    },

    handleSearch(e) {
      e.preventDefault()

      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        created_at_begin: formatRangeBeginDate(fieldsValue.created_at),
        created_at_end: formatRangeEndDate(fieldsValue.created_at)
      }
      this.$emit('submit', values)
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', { status: this.orderStatus })
    }
  }
}
</script>
